const disclaimerAcceptanceValidFor = 30 * 60 * 1000;

export const isDisclaimerAccepted = () => {
    try {
        const storedTimestamp = sessionStorage.getItem('readDisclaimer');
        if (!storedTimestamp) {
            return false;
        }

        const expiryTime = parseInt(storedTimestamp) + disclaimerAcceptanceValidFor;
        return new Date().getTime() <= expiryTime;
    } catch (e) {
        console.log(e);
        return false;
    }
};
